import type { SummaryObservation } from '../utils/summary-information-types';

import { IB22Dot } from './ib22-dot';

export function IB22Remarks({
    observations,
}: {
    observations: SummaryObservation[];
}) {
    return (
        <div className="flex gap-2">
            {observations
                && observations.map(observation => (
                    <IB22Dot
                        key={`${observation.Code}.${observation.Count}`}
                        count={observation.Count || 0}
                        color={observation.HexColorCode || '#a0a0a0'}
                    />
                ))}
        </div>
    );
}
